import { AxiosError } from 'axios';
import { ServerResponse, WithAuditDetails } from 'data/types';
import { History } from 'history';
import { Dispatch, Action } from 'redux';
import { RootState } from 'data/root.reducers';
import i18n from 'i18n';
import { showSuccessMessage, showError } from 'shared/toaster';
import { ThunkDispatch } from 'redux-thunk';
import * as api from './diameter.api';
import {
  DiameterActionTypes,
  GET_DIAMETER_LIST,
} from './diameter.types';

// eslint-disable-next-line import/prefer-default-export
export function getDiameters(
  deliveryFunctionId: string,
): DiameterActionTypes {
  return {
    type: GET_DIAMETER_LIST,
    payload: api.getDiameters(deliveryFunctionId),
  };
}
